module.exports = __webpack_public_path__ + "static/media/pizzabox.54420b7c.jpg";